<svg width="24" height="25" viewBox="0 0 24 25" fill="none" stroke="#2A3243" xmlns="http://www.w3.org/2000/svg">
  <path d="M19 12.5H5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M14 17.5L19 12.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M14 7.5L19 12.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>